<template>
  <v-row class="div-style">
    <div v-if="!skeletonLoader">
      <v-col cols="12" class="d-flex justify-center">
        <div class="position-relative">
          <upload-avtar
            :media="user.media"
            @profileUrl="profileUrl"
            @removeProfile="removeProfile"
          ></upload-avtar>
          <v-avatar color="#F0F0F0" size="150px">
            <v-img
              v-if="
                profile.media && profile.media.length && profile.media[0].url
              "
              :src="profile.media[0].url"
            ></v-img>
            <span
              v-else
              class="grey--text display-4 font-weight-bold pa-10 ml-1"
              >{{ profile | initial }}</span
            >
          </v-avatar>
        </div>
      </v-col>
      <v-col cols="12" class="text-center profile-name">
        <span> {{ user.firstName }} {{ user.lastName }} </span>
      </v-col>
      <v-col cols="12" class="pt-4">
        <short-bio-section :bio="user.bio" />
      </v-col>
      <account-delete />
    </div>
    <v-row
      v-if="skeletonLoader"
      class="px-6"
    >
      <v-col
        cols="12"
        class="px-0"
      >
        <v-skeleton-loader type="card, list-item-three-line, list-item-two-line" />
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
import UploadAvtar from "./UploadAvtar";
import { mapGetters } from "vuex";
import ShortBioSection from "./ShortBioSection";

export default {
  name: "ImageSection",
  components: {
    AccountDelete: () => import("./AccountDelete"),
    UploadAvtar,
    ShortBioSection,
  },
  props: {
    profile: Object
  },
  data() {
    return {
      closeOnContentClick: true,
      skeletonLoader: false,
    };
  },
  computed: {
    ...mapGetters("user", {
      user: "user"
    })
  },
  mounted() {
    this.$bus.$on('isProfileLoading', (val) => {
      this.isProfileLoad(val);
    });
     this.$bus.$on('isSaveEdit', (val) => {
      this.isProfileSave(val);
    });
  },
  methods: {
    profileUrl(response) {
      this.profile.media.push(response);
      this.$store.dispatch("user/setMedia", response);
      document.getElementById("settingId").click();
    },
    removeProfile() {
      this.profile.media = [];
      this.$store.dispatch("user/removeMedia");
    },
    isProfileLoad(val) {
      this.skeletonLoader = val;
    },
    isProfileSave(val) {
      this.skeletonLoader = val;
    },
    /*   bioUpdated(bio) {
      this.profile.bio = bio;
    }, */
    // updatedProfileInformation(object) {
    //   this.profile.firstName = object.firstName;
    //   this.profile.lastName = object.lastName;
    //   document.getElementById("settingId").click();
    // }
  }
};
</script>

<style scoped>
.avtar-cls {
  top: -83px;
  left: 0;
  right: 0;
  position: absolute;
  margin-left: 16px;
}
/* .avtar-parent {
  margin-top: 70px;
  position: relative;
} */
.div-style {
  display: block;
}
.position-relative {
  position: relative;
}
.profile-name {
  font-size: 18px;
  font-weight: 500;
  text-align: center;
}
.profile-delete {
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 0.75px;
  color: #ef4444;
  cursor: pointer;
}
</style>
